//#region src/generated/locales/en.ts
var templates = {
	"pd.submit.dialog.closeStay": `Edit data`,
	"pd.submit.dialog.startPage": `Go to homepage`
};
//#endregion
export { templates };
